var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9492 40C30.9668 40 39.8983 31.0457 39.8983 20C39.8983 8.9543 30.9668 0 19.9492 0C8.93153 0 0 8.9543 0 20C0 31.0457 8.93153 40 19.9492 40ZM16.7251 13.2322C15.7513 12.2559 14.1724 12.2559 13.1986 13.2322C12.2248 14.2086 12.2248 15.7915 13.1986 16.7678L16.4226 20L13.1986 23.2323C12.2248 24.2085 12.2248 25.7915 13.1986 26.7677C14.1724 27.744 15.7513 27.744 16.7251 26.7677L19.9492 23.5355L23.1732 26.7677C24.147 27.744 25.7259 27.744 26.6997 26.7677C27.6735 25.7915 27.6735 24.2085 26.6997 23.2323L23.4757 20L26.6997 16.7678C27.6735 15.7915 27.6735 14.2086 26.6997 13.2322C25.7259 12.2559 24.147 12.2559 23.1732 13.2322L19.9492 16.4645L16.7251 13.2322Z",
    fill: "#CC287B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcircle);
export default __webpack_public_path__ + "static/media/x circle.7a43b23b5d61151fac269d6ed18cae3e.svg";
export { ForwardRef as ReactComponent };